import React, { Component } from "react";
import PropTypes from "prop-types";
import "./index.css";

class SignaturePage extends Component {
  static propTypes = {
    getDocumentsToSign: PropTypes.func,
    url: PropTypes.string
  };

  resetSign() {
    const {
      getDocumentsToSign
    } = this.props;
    getDocumentsToSign(0,
      20);
  }

  render() {
    const { url } = this.props;

    return (
      <div>
        <div style={{ height: "100%", zIndex: 1 }}>
          <iframe
            id="signFrame"
            title="signatureIframe"
            style={{
              border: "0px",
              height: "80%",
              position: "absolute",
              display: "block",
              zIndex: "1"
            }}
            src={url}
          />
        </div>
      </div>
    );
  }
}

export default SignaturePage;
